var map = {
	"./lesson_4_1.pdf": 1080,
	"./lesson_4_2.pdf": 1081,
	"./lesson_4_3.pdf": 1082,
	"./lesson_4_4.pdf": 1083,
	"./lesson_4_5.pdf": 1084,
	"./lesson_4_6.pdf": 1085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1079;